// extracted by mini-css-extract-plugin
export var aircallIframe = "_dd-3";
export var fabContainer = "_dd-5";
export var fabRinging = "_dd-6";
export var loadingOverlay = "_dd-4";
export var pulse = "_dd-7";
export var widgetContent = "_dd-2";
export var widgetPanel = "_dd-0";
export var widgetPanelExpanded = "_dd-1";